/*eslint-disable*/
import React, { useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { IoChevronBackOutline } from 'react-icons/io5';
import Button from '../../../Component/Button/Button';
import DropDown from '../../../Component/DropDown/DropDown';
import FileUpload from '../../../Component/FileUpload';
import Input from '../../../Component/Input/Input';
import SideBarSkeleton from '../../../Component/SideBarSkeleton';
import TextArea from '../../../Component/TextArea';
import {
  defaultLocation,
  floorLevelOptions,
  furnitureOptions,
  languagesOptions,
  propertyAgeOptions,
  propertyClassificationOptions,
  propertyOrientationOptions,
  propertyPurposeOptions,
  rentType,
  propertyStatusOptions,
  roomsOptions,
  titleDeedOptions,
  propertyPurposeOptionsSell
} from '../../../constant/commonData';
import classes from './NewProperty.module.css';

import moment from 'moment';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import validator from 'validator';
import { Get } from '../../../Axios/AxiosFunctions';
import FormLanguages from '../../../Component/FormLanguages';
import { Loader } from '../../../Component/Loader';
import LocationComponent from '../../../Component/LocationComponent';
import LottieLoader from '../../../Component/LottieLoader/LottieLoader';
import UploadImageBox from '../../../Component/UploadImageBox';
import {
  BaseURL,
  CreateFormData,
  convertArrayKeysToObject,
  formatLabel
} from '../../../config/apiUrl';
import {
  useCreatePropertyMutation,
  useDeletePropertyMediaMutation,
  useLazyGetSinglePropertyQuery
} from '../../../store/apiSlice/apiSlice';
import { uploadImagesHelper } from '../../../utils/helpers';
import QuillInput from '../../../Component/QuillInput';
import { Divider } from '@mui/material';
import { mapMarker } from '../../../constant/imagePath';
import { MdAutoAwesome } from 'react-icons/md';

function NewProperty() {
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const [language, setLanguage] = useState(
    languagesOptions?.find((item) => item?.value === selectedLanguage)
  );

  const { t } = useTranslation(['dashboardProperties', 'locationComp'], {
    lng: language?.value
  });

  const slug = useParams()?.slug;

  const languagesKeysObject = convertArrayKeysToObject(languagesOptions?.map((e) => e?.value));
  const _propertyTypesOptions = useSelector((state) => state.commonReducer?.propertyTypes);
  const interiorAmenitiesOptions = useSelector((state) => state.commonReducer?.interiorAmenities);
  const exteriorAmenitiesOptions = useSelector((state) => state.commonReducer?.exteriorAmenities);
  const navigate = useNavigate();
  const [getSingleProperty, { isLoading: isGetting }] = useLazyGetSinglePropertyQuery();

  const [propertyTypesOptions, setPropertyTypesOptions] = useState(_propertyTypesOptions);
  // Language

  // new image states
  const [isUploadingImages, setIsUploadingImages] = useState(false);
  const [autoFillLoading, setAutoFillLoading] = useState(false);

  const [formState, setFormState] = useState({
    title: languagesKeysObject,
    description: languagesKeysObject,
    propertyPurpose: languagesKeysObject,
    rentType: languagesKeysObject,
    propertyClassification: languagesKeysObject,
    propertyType: languagesKeysObject,
    price: 0,
    netArea: 0,
    noOfRooms: null,
    noOfBathrooms: 0,
    floorLevel: null,
    furniture: languagesKeysObject,
    exAmenities: [],
    inAmenities: [],
    propertyStatus: languagesKeysObject,
    parkingSpace: 0,
    propertyAge: languagesKeysObject,
    propertyClassification: languagesKeysObject,
    // propertyOrientation: languagesKeysObject,
    propertyOrientation: [],
    images: [],
    planImages: [],
    videoLink: '',
    view360: '',
    // view360File: null,
    openHouseStartDate: '',
    openHouseEndDate: '',
    titleOfDeed: ''
  });

  const updateField = (key, value, isDropDown) => {
    setFormState((prev) => ({
      ...prev,
      [key]: isDropDown ? value : { ...prev[key], [language?.value]: value }
    }));
  };

  const [otherLocation, setOtherLocation] = useState({
    province: '',
    town: '',
    neighbourhood: '',
    address: '',
    ...defaultLocation
  });
  // Media Section States

  // Images

  const [uploadedImages, setUploadedImages] = useState([]);
  const [uploadedPlanImages, setUploadedPlanImages] = useState([]);
  const [createProperty, { isLoading }] = useCreatePropertyMutation();

  // For Delete Property Media
  const [deletePropertyMedia, { isLoading: isDeletingMedia }] = useDeletePropertyMediaMutation();

  const accessToken = useSelector((state) => state?.authReducer?.accessToken);
  // check if eligible for adding new property
  useEffect(() => {
    if (!slug) {
      const handleEligibility = async () => {
        const url = BaseURL(`users/check-limit?type=property`);
        const res = await Get(url, accessToken);
        if (res) {
          if (res?.data?.data === false) {
            toast.error(
              'You have reached the limit of adding new properties, please upgrade your plan'
            );
            navigate(-1);
          }
        }
      };

      handleEligibility();
    }

    setPropertyTypesOptions(_propertyTypesOptions);
  }, []);

  const getSinglePropertyData = async () => {
    const res = await getSingleProperty({ slug });
    const responseData = res?.data?.data;
    if (res?.data) {
      setFormState((prev) => ({
        ...prev,
        title: responseData?.title,
        description: responseData?.description,
        propertyPurpose: propertyPurposeOptionsSell?.find(
          (e) => e?.values?.en === responseData?.propertyPurpose?.en
        ),
        rentType: responseData?.rentType,
        propertyType: responseData?.propertyType,
        price: responseData?.price,
        netArea: responseData?.netArea,
        noOfRooms: responseData?.noOfRooms,
        noOfBathrooms: responseData?.noOfBathrooms,
        floorLevel: responseData?.floorLevel,
        furniture: responseData?.furniture,
        exAmenities: responseData?.exteriorAmenities,
        inAmenities: responseData?.interiorAmenities,
        propertyStatus: responseData?.propertyStatus,
        parkingSpace: responseData?.parkingSpace,
        propertyAge: responseData?.propertyAge,
        propertyClassification: responseData?.propertyClassification,
        propertyOrientation: responseData?.propertyOrientation,

        videoLink: responseData?.videoLink,
        view360: responseData?.threeSixtyViewLink,
        // view360File: !responseData?.threeSixtyViewLink?.includes('https://')
        //   ? responseData?.threeSixtyViewLink
        //   : null,
        openHouseStartDate: responseData?.openHouseStartDate
          ? moment(responseData?.openHouseStartDate).format('YYYY-MM-DDTHH:mm')
          : '',
        openHouseEndDate: responseData?.openHouseEndDate
          ? moment(responseData?.openHouseEndDate).format('YYYY-MM-DDTHH:mm')
          : '',
        planImages: [],
        images: [],
        titleOfDeed: responseData?.titleOfDeed
      }));
      setOtherLocation((prev) => ({
        ...prev,
        province: responseData?.province,
        town: responseData?.town,
        neighbourhood: responseData?.neighborhood,
        address: responseData?.address,
        lat: responseData?.location?.coordinates[1],
        lng: responseData?.location?.coordinates[0]
      }));
      setUploadedImages(responseData?.images);
      setUploadedPlanImages(responseData?.planImages);
    }
  };
  useEffect(() => {
    if (slug) {
      getSinglePropertyData();
    }
  }, [slug]);

  const validateParams = () => {
    const multiLanguageParams = {
      ...(slug ? {} : { title: formState?.title }),
      description: formState?.description
    };

    let params = {
      propertyPurpose: formState?.propertyPurpose?.values,
      rentType: formState.propertyPurpose?.values?.en != 'Buy' ? formState?.rentType : null,
      propertyType: formState?.propertyType?._id,
      price: String(formState?.price),
      netArea: String(formState?.netArea),
      noOfRooms: formState?.noOfRooms,
      noOfBathrooms: String(formState?.noOfBathrooms),
      floorLevel: formState?.floorLevel,
      furniture: formState?.furniture,
      exteriorAmenities: formState?.exAmenities?.map((e) => e?._id),
      interiorAmenities: formState?.inAmenities?.map((e) => e?._id),
      propertyStatus: formState?.propertyStatus,
      parkingSpace: String(formState?.parkingSpace),
      propertyAge: formState?.propertyAge,
      propertyClassification: formState?.propertyClassification,
      propertyOrientation: formState?.propertyOrientation,
      titleOfDeed: formState?.titleOfDeed,
      address: otherLocation?.address,
      lng: otherLocation?.lng,
      lat: otherLocation?.lat,
      province: otherLocation?.province?._id,
      town: otherLocation?.town?._id,
      neighborhood: otherLocation?.neighbourhood?._id,
      threeSixtyViewLink: formState?.view360,

      // ...(!!formState?.view360File
      //   ? { threeSixtyViewLink: formState?.view360File }
      //   : { threeSixtyViewLink: formState?.view360 }),

      videoLink: formState?.videoLink,

      openHouseStartDate: formState?.openHouseStartDate,
      openHouseEndDate: formState?.openHouseEndDate
    };

    for (let lang in languagesKeysObject) {
      const langLabel = languagesOptions?.find((e) => e?.value === lang)?.label;
      // validate multiLanguageParams
      for (let key in multiLanguageParams) {
        if (!multiLanguageParams[key][lang]) {
          toast.error(
            t('toast.pleaseFillTheFieldInLanguage', {
              field: formatLabel(key),
              language: langLabel
            })
          );
          return [false, null];
        }
      }

      // validate params
      for (let key in params) {
        // skip the following keys
        if (
          [
            'videoLink',
            'openHouseStartDate',
            'openHouseEndDate',
            'view360',
            'threeSixtyViewLink'
          ].includes(key)
        ) {
          continue;
        }

        if (
          formState.propertyPurpose?.values?.en === 'Buy' &&
          (key === 'rentType' || key === 'otherSpecificKeyToIgnore')
        ) {
          continue;
        }
        if (
          !params[key] &&
          (formState.propertyClassification?.en == 'Commercial' ? key != 'noOfBathrooms' : true)
        ) {
          toast.error(t('toast.pleaseFillTheFields', { field: formatLabel(key) }));
          return [false, null];
        }
        if (Array.isArray(params[key]) && params[key].length === 0) {
          toast.error(t('toast.pleaseAddSelectField', { field: formatLabel(key) }));
          return [false, null];
        }

        // if params[key] is an object, check if it has a value in all keys
        if (typeof params[key] === 'object') {
          for (let k in params[key]) {
            const langLabel_ = languagesOptions?.find((e) => e?.value === k)?.label;
            if (!params[key][k]) {
              toast.error(`Please fill the ${formatLabel(key)} field in language "${langLabel_}".`);
              return [false, null];
            }
          }
        }
        // if key includes the following, it should be a valid number, > 0
        if (
          [
            'price',
            'netArea',
            formState.propertyClassification?.en != 'Commercial' ? 'noOfBathrooms' : '',
            'parkingSpace'
          ].includes(key)
        ) {
          if (!validator.isNumeric(params[key]) || params[key] <= 0) {
            toast.error(`Please enter a valid ${formatLabel(key)}.`);
            return [false, null];
          }
        }
        // if key is a url
        // if (['videoLink', !!formState?.view360File ? '' : 'threeSixtyViewLink'].includes(key)) {
        // if (['videoLink', 'threeSixtyViewLink'].includes(key)) {
        if (['videoLink'].includes(key)) {
          if (!validator.isURL(params[key])) {
            toast.error(t('toast.pleaseEnterValidField', { field: formatLabel(key) }));
            return [false, null];
          }
        }
      }
    }

    params = {
      ...params,
      // images: formState?.images,
      images: uploadedImages,
      // planImages: formState?.planImages
      planImages: uploadedPlanImages
    };
    //  Plan Images and Images
    if (uploadedImages?.length + params?.images?.length < 3) {
      toast.error(t('toast.addImages'));
      return [false, null];
    }
    if (uploadedPlanImages?.length + params?.planImages?.length < 3) {
      toast.error(t('toast.planImages'));
      return [false, null];
    }

    // threeSixtyViewLink must be a valid url
    if (params?.threeSixtyViewLink && !validator.isURL(params?.threeSixtyViewLink)) {
      // toast.error(`${t('toast.pleaseEnterValidField')}`, { field: '360 View Link' });
      toast.error(t('toast.pleaseEnterValidField', { field: formatLabel('threeSixtyViewLink') }));
      return [false, null];
    }
    return [true, { ...params, ...multiLanguageParams }];
  };

  const handleSubmit = async () => {
    const [isValid, params] = validateParams();

    params.propertyOrientation = JSON.stringify(params?.propertyOrientation);
    if (!isValid) return;
    const formData = await CreateFormData(params);

    // api
    const response = await createProperty({ data: formData, ...(slug && { slug }) });
    if (response.data) {
      toast.success(
        `${t('toast.property')} ${slug ? t('toast.updated') : t('toast.added')} ${t(
          'toast.successfully'
        )}`
      );
      navigate('/agent/properties-management');
    }
  };

  const deleteMedia = async (e) => {
    const res = await deletePropertyMedia(e);
    if (res?.data) {
      if (e?.type == 'images') {
        setUploadedImages((prev) => prev.filter((a) => a !== e?.key));
      } else {
        setUploadedPlanImages((prev) => prev.filter((a) => a !== e?.key));
      }
      toast.success(t('toast.mediaDeletedSuccessfully'));
    }
  };

  const handleAutoFill = async () => {
    setAutoFillLoading(true);
    const multiLanguageFields = {
      title: formState?.title,
      description: formState?.description
    };

    const currentLang = language?.value;
    const langLabel = languagesOptions?.find((e) => e?.value === currentLang)?.label ?? 'Unknown';

    for (const key in multiLanguageFields) {
      const value = multiLanguageFields[key]?.[currentLang]?.trim();
      const label = formatLabel(key);
      if (!value) {
        toast.error(`Missing field "${label}" in ${langLabel}`);
        setAutoFillLoading(false);
        return;
      }
    }

    const fallbackData = {
      title: {
        en: 'Property Title',
        tr: 'Emlak Başlığı',
        ru: 'Название недвижимости',
        de: 'Immobilientitel',
        fr: 'Titre de propriété',
        ar: 'عنوان العقار',
        fa: 'عنوان ملک'
      },
      description: {
        en: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Property Description</span></p>',
        tr: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Emlak Açıklaması</span></p>',
        ru: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Описание недвижимости</span></p>',
        de: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Immobilienbeschreibung</span></p>',
        fr: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Description de la propriété</span></p>',
        ar: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">وصف العقار</span></p>',
        fa: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">توضیحات ملک</span></p>'
      }
    };

    // Show loading toast
    const loadingToast = toast.loading('Translating fields to other languages...');

    try {
      const response = await fetch(
        'https://turegu-ai-api.devcustomprojects.online/translate/property',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            ...multiLanguageFields
          }),
          redirect: 'follow'
        }
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      setFormState((prevState) => ({
        ...prevState,
        title: {
          ...prevState.title,
          ...data?.title
        },
        description: {
          ...prevState.description,
          ...data?.description
        }
      }));

      toast.success(`Fields translated successfully for all languages!`);
    } catch (error) {
      // setFormState((prevState) => ({
      //   ...prevState,
      //   title: {
      //     ...prevState.title,
      //     ...fallbackData.title
      //   },
      //   description: {
      //     ...prevState.description,
      //     ...fallbackData.description
      //   }
      // }));

      toast.warning('Translation service unavailable.');
    } finally {
      toast.dismiss(loadingToast);
      setAutoFillLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
       @media (max-width: 768px) {
      .container{
      max-width: 100% !important;
      }
     
      .LocationComponent_row_main__ZtY4U{
      row-gap: 25px !important;
      }
      }
      @media (max-width: 420px) {
      .LocationComponent_row_main__ZtY4U{
      row-gap: 15px !important;
      }
      .button_btn__vXed8{
      padding-inline: 10px !important;}
      }
      `}
      </style>
      <SideBarSkeleton>
        {isGetting ? (
          <Loader className={classes?.loader} />
        ) : (
          <Container fluid className={[classes.page].join(' ')}>
            <Row>
              <Col md={12} className={classes.mb30}>
                <Button
                  leftIcon={<IoChevronBackOutline />}
                  variant=""
                  className={[classes.backBtn, 'ltr'].join(' ')}
                  onClick={() => {
                    navigate('/agent/properties-management');
                  }}>
                  {t('form.goBack')}
                </Button>
              </Col>
              <Col md={12}>
                <div
                  className={[
                    classes.formBg,
                    ['ar', 'fa']?.includes(language?.value) ? 'rtl' : 'ltr'
                  ].join(' ')}>
                  <Container>
                    <Row className={classes.formRow}>
                      <Col md={12} className="d-flex justify-content-between align-items-center">
                        <h3 className={classes.title}>
                          {slug
                            ? t('form.titleEdit', { lng: language?.value })
                            : t('form.titleCreate')}
                        </h3>
                        <Button
                          variant="secondary"
                          onClick={handleAutoFill}
                          disabled={autoFillLoading}
                          className="d-flex align-items-center gap-2"
                          customStyle={{
                            width: 'fit-content'
                          }}>
                          {autoFillLoading ? (
                            <Spinner size="sm" className="me-2" />
                          ) : (
                            <MdAutoAwesome size={20} className="me-2" />
                          )}
                          {t('form.autoFill')}
                        </Button>
                      </Col>
                      <Col md={12} className="languageBar">
                        <div className={classes.headAndDropDown}>
                          <h4>{t('form.tagline')}</h4>
                          <FormLanguages
                            value={language}
                            setter={setLanguage}
                            className={classes.languagesMain}
                          />
                        </div>
                      </Col>
                      <Col md={12}>
                        <Input
                          label={t('form.propertyTitleLabel')}
                          placeholder={t('form.propertyTitlePlaceholder')}
                          variant="dashboard"
                          value={formState.title[language?.value]}
                          setValue={(e) => updateField('title', e)}
                          disabled={slug}
                          length={60}
                        />
                      </Col>

                      <Col md={12}>
                        <QuillInput
                          key={`description-${language?.value}`}
                          label={t('form.propertyDescriptionLabel')}
                          value={formState.description[language?.value]}
                          setter={(e) => updateField('description', e)}
                          language={language?.value}
                        />
                      </Col>
                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyPurposeLabel')}
                          placeholder={t('form.propertyPurposePlaceholder')}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          variant="dashboard"
                          value={formState.propertyPurpose}
                          setValue={(e) => updateField('propertyPurpose', e, true)}
                          options={propertyPurposeOptionsSell}
                          getOptionValue={(e) => {
                            return e?.values?.[language?.value];
                          }}
                          getOptionLabel={(e) => {
                            return e?.labels?.[language?.value];
                          }}
                        />
                      </Col>
                      {/* propertyClassification */}
                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyClassification')}
                          placeholder={t('form.propertyPurposePlaceholder')}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          variant="dashboard"
                          value={formState.propertyClassification}
                          setValue={(e) => {
                            updateField('propertyClassification', e, true);
                            // reset propertyType
                            setFormState((prev) => ({
                              ...prev,
                              propertyType: languagesKeysObject
                            }));

                            // propertyTypesOptions => sort by propertyClassification
                            const filteredPropertyTypes = _propertyTypesOptions?.filter(
                              (ele) => ele?.type === e?.en?.toLowerCase()
                            );
                            setPropertyTypesOptions(filteredPropertyTypes);
                          }}
                          options={propertyClassificationOptions}
                          getOptionValue={(e) => {
                            return e?.[language?.value];
                          }}
                          getOptionLabel={(e) => {
                            return e?.[language?.value];
                          }}
                        />
                      </Col>

                      {formState.propertyPurpose?.values?.en != 'Buy' && (
                        <Col md={12}>
                          <DropDown
                            label={t('form.propertyDurationLabel')}
                            // placeholder={t('form.propertyPurposePlaceholder')}
                            indicatorColor="var(--dashboard-text-gray-clr)"
                            variant="dashboard"
                            value={formState.rentType}
                            setValue={(e) => updateField('rentType', e, true)}
                            options={rentType}
                            getOptionValue={(e) => {
                              return e?.[language?.value];
                            }}
                            getOptionLabel={(e) => {
                              return e?.[language?.value];
                            }}
                          />
                        </Col>
                      )}

                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyTypeLabel')}
                          placeholder={t('form.propertyTypePlaceholder')}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          variant="dashboard"
                          value={formState.propertyType}
                          setValue={(e) => updateField('propertyType', e, true)}
                          optionValue={'_id'}
                          getOptionLabel={(e) => {
                            return e?.title?.[language?.value];
                          }}
                          options={propertyTypesOptions}
                          disabled={!formState.propertyClassification?.en}
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          type={'number'}
                          label={t(
                            formState.propertyPurpose?.values?.en == 'Rent'
                              ? 'form.propertyRentPriceLabel'
                              : 'form.propertyPriceLabel'
                          )}
                          placeholder={t(
                            formState.propertyPurpose?.values?.en == 'Rent'
                              ? 'form.propertyRentPricePlaceholder'
                              : 'form.propertyPricePlaceholder'
                          )}
                          variant="dashboard"
                          value={formState.price}
                          setValue={(e) => setFormState((prev) => ({ ...prev, price: e }))}
                        />
                      </Col>
                      {/* <Col md={6}>
                    <DropDown
                      label={'Rent Duration Period*'}
                      placeholder={'Select Rent Duration Period'}
                      variant="dashboard"
                      options={rentDurationPeriodOptions}
                      indicatorColor="var(--dashboard-text-gray-clr)"
                      value={rentDurationPeriod}
                      setValue={setRentDurationPeriod}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      label={'Rent Duration*'}
                      placeholder={'Enter Duration'}
                      variant="dashboard"
                      value={rentDuration}
                      setValue={setRentDuration}
                    />
                  </Col> */}
                      <Col md={6}>
                        <Input
                          type={'number'}
                          label={t('form.propertyAreaLabel')}
                          placeholder={t('form.propertyAreaPlaceholder')}
                          variant="dashboard"
                          value={formState.netArea}
                          setValue={(e) => setFormState((prev) => ({ ...prev, netArea: e }))}
                        />
                      </Col>

                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyRoomsLabel')}
                          placeholder={t('form.propertyRoomsPlaceholder')}
                          variant="dashboard"
                          options={roomsOptions}
                          optionLabel={[language?.value]}
                          optionValue={[language?.value]}
                          value={formState.noOfRooms}
                          setValue={(e) => setFormState((prev) => ({ ...prev, noOfRooms: e }))}
                        />
                      </Col>
                      {formState.propertyClassification?.en != 'Commercial' && (
                        <Col md={6}>
                          <Input
                            // disabled={formState.propertyClassification?.en == 'Commercial'}
                            type={'number'}
                            label={t('form.propertyBathroomsLabel')}
                            placeholder={t('form.propertyBathroomsPlaceholder')}
                            variant="dashboard"
                            value={formState.noOfBathrooms}
                            setValue={(e) =>
                              setFormState((prev) => ({ ...prev, noOfBathrooms: e }))
                            }
                          />
                        </Col>
                      )}
                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyFloorLevelLabel')}
                          placeholder={t('form.propertyFloorLevelPlaceholder')}
                          options={floorLevelOptions}
                          variant="dashboard"
                          value={formState.floorLevel}
                          optionLabel={[language?.value]}
                          optionValue={[language?.value]}
                          setValue={(e) => setFormState((prev) => ({ ...prev, floorLevel: e }))}
                        />
                      </Col>

                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyFurnitureLabel')}
                          placeholder={t('form.propertyFurniturePlaceholder')}
                          variant="dashboard"
                          options={furnitureOptions}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          value={formState.furniture}
                          setValue={(e) => updateField('furniture', e, true)}
                          getOptionValue={(e) => {
                            return e?.[language?.value];
                          }}
                          getOptionLabel={(e) => {
                            return e?.[language?.value];
                          }}
                        />
                      </Col>

                      <Col md={6}>
                        <DropDown
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          label={t('form.propertyExteriorAmenities')}
                          placeholder={t('form.propertyExteriorAmenitiesPlaceholder')}
                          variant="dashboard"
                          value={formState.exAmenities}
                          isMulti={true}
                          getOptionLabel={(e) => e?.title?.[language?.value]}
                          optionValue={'_id'}
                          setValue={(e) => setFormState((prev) => ({ ...prev, exAmenities: e }))}
                          options={exteriorAmenitiesOptions}
                        />
                      </Col>
                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyInteriorAmenities')}
                          placeholder={t('form.propertyInteriorAmenitiesPlaceholder')}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          variant="dashboard"
                          value={formState.inAmenities}
                          isMulti={true}
                          optionValue={'_id'}
                          getOptionLabel={(e) => e?.title?.[language?.value]}
                          setValue={(e) => setFormState((prev) => ({ ...prev, inAmenities: e }))}
                          options={interiorAmenitiesOptions}
                        />
                      </Col>

                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyStatusLabel')}
                          placeholder={t('form.propertyStatusLabelPlaceholder')}
                          options={propertyStatusOptions}
                          variant="dashboard"
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          value={formState.propertyStatus}
                          setValue={(e) => updateField('propertyStatus', e, true)}
                          getOptionValue={(e) => e?.[language?.value]}
                          getOptionLabel={(e) => e?.[language?.value]}
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          label={t('form.propertyParkingSpaceLabel')}
                          placeholder={t('form.propertyParkingSpacePlaceholder')}
                          variant="dashboard"
                          value={formState.parkingSpace}
                          setValue={(e) => setFormState((prev) => ({ ...prev, parkingSpace: e }))}
                          type={'number'}
                        />
                      </Col>
                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyAgeLabel')}
                          placeholder={t('form.propertyAgePlaceholder')}
                          variant="dashboard"
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          value={formState.propertyAge}
                          setValue={(e) => updateField('propertyAge', e, true)}
                          options={propertyAgeOptions}
                          getOptionValue={(e) => e?.[language?.value]}
                          getOptionLabel={(e) => e?.[language?.value]}
                        />
                      </Col>
                      {/* <Col md={6}>
                      <DropDown
                        label={t('form.propertyOrientationLabel')}
                        placeholder={t('form.propertyOrientationPlaceholder')}
                        indicatorColor="var(--dashboard-text-gray-clr)"
                        variant="dashboard"
                        value={formState.propertyOrientation}
                        setValue={(e) => updateField('propertyOrientation', e, true)}
                        options={propertyOrientationOptions}
                        getOptionValue={(e) => e?.[language?.value]}
                        getOptionLabel={(e) => {
                          return e?.[language?.value];
                        }}
                      />
                    </Col> */}
                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyOrientationLabel')}
                          placeholder={t('form.propertyOrientationPlaceholder')}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          variant="dashboard"
                          value={
                            formState.propertyOrientation.length > 0
                              ? formState.propertyOrientation
                              : []
                          }
                          setValue={(e) => updateField('propertyOrientation', e, true)}
                          options={propertyOrientationOptions}
                          getOptionValue={(e) => e?.en}
                          getOptionLabel={(e) => e?.en}
                          isMulti={true}
                        />
                      </Col>

                      <Col md={6}>
                        <DropDown
                          label={t('form.propertyTitleDeedLabel')}
                          placeholder={t('form.propertyTitleDeedPlaceholder')}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          variant="dashboard"
                          value={formState.titleOfDeed}
                          setValue={(e) => updateField('titleOfDeed', e, true)}
                          options={titleDeedOptions}
                          getOptionValue={(e) => e?.[language?.value]}
                          getOptionLabel={(e) => {
                            return e?.[language?.value];
                          }}
                        />
                      </Col>

                      {/* Location   */}

                      <LocationComponent
                        t={t('location')}
                        setLocationState={setOtherLocation}
                        locationState={otherLocation}
                        selectedLanguage={language}
                        markerIcon={mapMarker}
                      />

                      {/* End of Location */}
                      {/* Media */}
                      <Col md={12}>
                        <h4>{t('form.propertyMedia')}</h4>
                      </Col>
                      <Col md={12}>
                        <label className={classes.label}>{t('form.propertyImagesLabel')}</label>
                        <Row className="gy-3">
                          {uploadedImages
                            // ?.filter((e) => typeof e == 'string')
                            ?.map((item, index) => (
                              <Col md={3} key={index}>
                                <UploadImageBox
                                  value={item}
                                  edit={false}
                                  onDelete={() => {
                                    deleteMedia({ slug, type: 'images', key: item });
                                  }}
                                />
                              </Col>
                            ))}
                        </Row>
                      </Col>
                      <Col md={12}>
                        <FileUpload
                          files={formState.images}
                          setFiles={(e) => {
                            uploadImagesHelper({
                              images: e,
                              setIsLoading: setIsUploadingImages,
                              setImages: setUploadedImages,
                              token: accessToken
                            });
                          }}
                          acceptTypes={['png', 'jpg', 'jpeg']}
                          text={t('form.dragAndDrop')}
                          orText={t('form.orText')}
                          buttonLabel={t('form.browseFiles')}
                        />
                      </Col>
                      <Divider className={classes.divider} />
                      <Col md={12}>
                        <label className={classes.label}>{t('form.propertyPlansLabel')}</label>

                        <Row className="gy-3">
                          {uploadedPlanImages?.map((item, index) => (
                            <Col md={3} key={index}>
                              <UploadImageBox
                                value={item}
                                edit={false}
                                onDelete={() => {
                                  deleteMedia({ slug, type: 'planImages', key: item });
                                }}
                              />
                            </Col>
                          ))}
                        </Row>
                      </Col>

                      <Col md={12}>
                        <FileUpload
                          files={formState.planImages}
                          setFiles={(e) => {
                            uploadImagesHelper({
                              images: e,
                              setIsLoading: setIsUploadingImages,
                              setImages: setUploadedPlanImages,
                              token: accessToken
                            });
                          }}
                          acceptTypes={['png', 'jpg', 'jpeg']}
                          text={t('form.dragAndDrop')}
                          orText={t('form.orText')}
                          buttonLabel={t('form.browseFiles')}
                        />
                      </Col>
                      <Col md={12}>
                        <Input
                          label={t('form.propertyVideoLabel')}
                          placeholder={t('form.propertyVideoPlaceholder')}
                          variant="dashboard"
                          value={formState.videoLink}
                          setValue={(e) => setFormState((prev) => ({ ...prev, videoLink: e }))}
                        />
                      </Col>
                      <Col md={12}>
                        <label className={classes.label}>{t('form.property360Link')}</label>
                        <div className={classes.linkAndUpload}>
                          <Input
                            placeholder={t('form.property360LinkPlaceholder')}
                            variant="dashboard"
                            value={formState.view360}
                            setValue={(e) => setFormState((prev) => ({ ...prev, view360: e }))}
                            className={classes.linkInput}
                            // disabled={!!formState.view360File}
                          />
                          {/* <span>--- {t('form.orText')} ---</span>
                        <UploadImageBox
                          setValue={(e) => {
                            if (!['image/png', 'image/jpg', 'image/jpeg'].includes(e?.type)) {
                              return toast.error(t('toast.fileType'));
                            }
                            setFormState((prev) => ({ ...prev, view360File: e }));
                          }}
                          value={formState.view360File}
                          label={t('form.property360Upload')}
                          // btnLabel={t('form.property360UploadBtn')}
                          disabled={!!formState.view360}
                          onDelete={() => {
                            setFormState((prev) => ({ ...prev, view360File: null }));
                          }}
                        /> */}
                        </div>
                      </Col>

                      <Col md={6}>
                        <Input
                          label={t('form.propertyOpenHouseLabel')}
                          type={'datetime-local'}
                          variant="dashboard"
                          value={formState.openHouseStartDate}
                          min={moment().format('YYYY-MM-DDTHH:mm')}
                          setValue={(e) => {
                            const thisX = moment().format('x');
                            const eX = moment(e).format('x');

                            if (thisX > eX) {
                              return toast.error(t('toast.dateSelectionError'));
                            }
                            setFormState((prev) => ({ ...prev, openHouseStartDate: e }));

                            // if (moment(e).isBefore(moment().format())) {
                            //   return toast.error(t('toast.dateSelectionError'));
                            // } else {
                            //   setFormState((prev) => ({ ...prev, openHouseStartDate: e }));
                            // }
                          }}
                        />
                      </Col>
                      <Col md={6} className="aEnd">
                        <Input
                          label={t('form.propertyOpenHouseEndingLabel')}
                          type={'datetime-local'}
                          variant="dashboard"
                          value={formState.openHouseEndDate}
                          min={moment().format('YYYY-MM-DDTHH:MM')}
                          setValue={(e) => {
                            if (moment(e).isBefore(formState.openHouseStartDate)) {
                              return toast.error(t('toast.startDateError'));
                            } else {
                              setFormState((prev) => ({ ...prev, openHouseEndDate: e }));
                            }
                          }}
                        />
                      </Col>

                      <Col md={12} className={classes.btnDiv}>
                        <Button className={classes.btn} disabled={isLoading} onClick={handleSubmit}>
                          {t(
                            `form.${
                              isLoading
                                ? slug
                                  ? 'updateBtnLoading'
                                  : 'saveBtnLoading'
                                : slug
                                ? 'updateBtn'
                                : 'create'
                            }`
                          )}
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Col>
            </Row>
          </Container>
        )}

        {(isUploadingImages || isDeletingMedia) && <LottieLoader />}
      </SideBarSkeleton>
    </>
  );
}

export default NewProperty;
